exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-nav-bar-nav-item .uu5-bricks-dropdown-button {\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n.uu5-bricks-nav-bar-nav-item .uu5-bricks-dropdown-button,\n.uu5-bricks-nav-bar-nav-item .uu5-bricks-dropdown-button:active,\n.uu5-bricks-nav-bar-nav-item .uu5-bricks-dropdown-button:focus,\n.uu5-bricks-nav-bar-nav-item .uu5-bricks-dropdown-button:active:focus {\n  box-shadow: none;\n  background-color: transparent;\n  border: none;\n  color: #777;\n}\n.uu5-bricks-nav-bar-nav-item .uu5-bricks-link {\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/nav-bar-nav-item.less
// module id = 236
// module chunks = 0